import { createElement } from "react"
import { createRoot } from "react-dom/client"

const roots = new Map()

function unmount(node) {
  roots.get(node).unmount()
  roots.delete(node)
}

const ReactRailsUJS = {
  findDOMNodes() {
    return document.querySelectorAll("[data-react-class]")
  },

  // Safe to call after inserting HTML: mounted islands keep their state, and islands removed from the page are unmounted.
  mountComponents() {
    roots.forEach((_root, node) => node.isConnected || unmount(node))

    this.findDOMNodes().forEach(node => {
      if (roots.has(node)) return

      const componentLocation = node.getAttribute("data-react-class").split(".")
      const propsJSON = node.getAttribute("data-react-props")
      const props = propsJSON ? JSON.parse(propsJSON) : {}

      const componentPath = componentLocation.slice(0, -1).reduce((acc, part) => acc[part], window)
      const componentName = componentLocation[componentLocation.length - 1]
      const Component = componentPath[componentName]

      if (Component) {
        const root = createRoot(node)
        root.render(createElement(Component, props))
        roots.set(node, root)
      } else {
        console.error(`Component "${componentName}" not found in registry`)
      }
    })
  },

  unmountComponents() {
    roots.forEach((_root, node) => unmount(node))
  },

  setupEvents() {
    document.addEventListener("DOMContentLoaded", () => {
      this.mountComponents()
    })
  },
}

ReactRailsUJS.setupEvents()

export default ReactRailsUJS
